import { render, staticRenderFns } from "./AgentPaSale.vue?vue&type=template&id=983f2d68"
import script from "./AgentPaSale.vue?vue&type=script&lang=js"
export * from "./AgentPaSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports